import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.41 26.59l-7.35-7.36a11 11 0 10-2.83 2.83l7.36 7.35a2 2 0 002.82-2.82zM13 20a7 7 0 117-7 7 7 0 01-7 7z"/><path d="M17 12H9a1 1 0 00-.7 1.69A1 1 0 009 14h8a1 1 0 000-2z"/>';
export var ZoomOutSVG = function ZoomOutSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ZoomOutSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ZoomOutSVG);